import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const CommunityDetail = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const [item] = useState(location?.state?.item);

  const panelTitle = {
    fontSize: "18px",
    paddingTop: "10px",
    paddingBottom: "10px",
    texAlign: "left",
    fontWeight: 600,
  };
  const body = {
    padding: "10px",
    backgroundColor: "#fff",
    marginLeft: "20px",
    marginRight: "20px",
    borderWidth: "1px",
    borderRadius: "4px",
  };
  const subTitle = {
    fontSize: "14px",
    color: "#76838f",
  };
  const head = {
    fontSize: "16px",
    color: "#000",
  };
  return (
    <div className="page-content read container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("COMMUNITY")}</h1>
            <p style={subTitle}>{item?.communityTitle}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("COMMUNITY_AR")}</h1>
            <p style={subTitle}>{item?.communityTitleAr}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_SHORT_DESCRIPTION")}</h1>
            <p style={subTitle}>{item?.shortDescription}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_SHORT_DESCRIPTION_AR")}</h1>
            <p style={subTitle}>{item?.shortDescriptionAr}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_CTA_TITLE")}</h1>
            <p style={subTitle}>{item?.ctaTitle}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_CTA_TITLE_AR")}</h1>
            <p style={subTitle}>{item?.ctaTitleAr}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_CTA_SUBTITLE")}</h1>
            <p style={subTitle}>{item?.ctaSubtitle}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_CTA_SUBTITLE_AR")}</h1>
            <p style={subTitle}>{item?.ctaSubtitleAr}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("O_SUBTITLE")}</h1>
            <p style={subTitle}>{item?.subTitle}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("SUB_TITLE_AR")}</h1>
            <p style={subTitle}>{item?.subTitleAr}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("STATIC_TITLE")}</h1>
            <p style={subTitle}>{item?.metaTitle}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("META_TITLE_AR")}</h1>
            <p style={subTitle}>{item?.metaTitleAr}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("KEYWORD")}</h1>
            <p style={subTitle}>{item?.keyword}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("KEYWORD_AR")}</h1>
            <p style={subTitle}>{item?.keywordAr}</p>
          </div>
        
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("STATIC_DESCRIPTION")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.metaDescription}}></p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("META_DESCRIPTION_AR")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.metaDescriptionAr}}></p>
          </div>

          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("OFFERS_DESCRIPTION")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.description}}></p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("DESCRIPTION_AR")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.descriptionAr}}></p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("COMMUNITY_ICON")}</h1>
            <div
              style={{
                width: "100px",
                height: "100px",
                display: "inline-block",
                marginRight: "10px",
                overflow: 'hidden',
              }}
            >
              <img src={item?.communityIcon} alt="unitImage" />
            </div>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("COMMUNITY_BANNER")}</h1>
            <div
              style={{
                width: "200px",
                height: "150px",
                display: "inline-block",
                marginRight: "10px",
                overflow: 'hidden',
              }}
            >
              <img src={item?.banner} alt="unitImage" />
            </div>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("IMAGE_GALLERY")}</h1>
            {item?.imageGallery?.map((img, index) => {
              return (
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    display: "inline-block",
                    marginRight: "10px",
                    overflow: 'hidden',
                  }}
                >
                  <img id={index} src={img} alt="unitImage" />
                </div>
              );
            })}
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("ATTRACTION")}</h1>
            {item?.attractions?.map((img, index) => {
              return (
                <>
                  <div>
                    <p style={head}>{t("O_TITLE")}</p>
                    <p style={subTitle}>{img?.title}</p>
                  </div>
                  <div>
                    <p style={head}>{t("TITLE_AR")}</p>
                    <p style={subTitle}>{img?.titleAr}</p>
                  </div>
                  <div>
                    <p style={head}>{t("O_ICON")}</p>
                    <div
                      style={{
                        width: "100px",
                        height: "100px",
                        display: "inline-block",
                        marginRight: "10px",
                        overflow: 'hidden',
                      }}
                    >
                      <img id={index} src={img?.icon} alt="icon" />
                    </div>
                  </div>
                </>
              );
            })}
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("FEATURES")}</h1>
            {item?.features?.map((feature, index) => {
              return (
                <p key={index} style={subTitle}>
                  {feature?.title}
                </p>
              );
            })}
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("FEATURES_AR")}</h1>
            {item?.features?.map((feature, index) => {
              return (
                <p key={index} style={subTitle}>
                  {feature?.titleAr}
                </p>
              );
            })}
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("FAQ")}</h1>
            {item?.faq?.map((faq) => {
              return (
                <div>
                  <div>
                    <p style={head}>{t("QUESTION")}</p>
                    <p style={subTitle}>{faq?.question}</p>
                  </div>
                  <div>
                    <p style={head}>{t("QUESTION_AR")}</p>
                    <p style={subTitle}>{faq?.questionAr}</p>
                  </div>
                  <div>
                    <p style={head}>{t("ANSWER")}</p>
                    <p style={subTitle} dangerouslySetInnerHTML={{ __html: faq?.answer}} ></p>
                  </div>
               
                  <div>
                    <p style={head}>{t("ANSWER_AR")}</p>
                    <p style={subTitle} dangerouslySetInnerHTML={{ __html: faq?.answerAr}}></p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("DESCRIPTION_SECOND")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.description2}}></p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("DESCRIPTION_SECOND")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.description2Ar}}></p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("DESCRIPTION_THIRD")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.description3}}></p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("DESCRIPTION_THIRD_AR")}</h1>
            <p style={subTitle} dangerouslySetInnerHTML={{ __html: item?.description3Ar}}></p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>{t("SHOW_HOME")}</h1>
            <p style={subTitle}>{item?.isShowHome ? 'Yes' : 'false'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityDetail;
